// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/thin/arrow-down-long.svg: path and width byte-identical (components/icons, Phase 5).
export default function ThinArrowDownLongIcon({
  className,
}: {
  className?: string
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      data-page-icon="thin/arrow-down-long"
      fill="currentColor"
      focusable="false"
      height="1em"
      overflow="visible"
      viewBox="0 0 384 512"
      width="0.75em"
    >
      <path d="M186.3 509.7c3.1 3.1 8.2 3.1 11.3 0l152-152c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L200 484.7 200 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 476.7L45.7 346.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l152 152z" />
    </svg>
  )
}
